import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useOrganization } from '@/contexts/organization-context'

export function OrgRouteValidator({ children }: { children: React.ReactNode }) {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  const { organizations, loading } = useOrganization()
  const [isValidating, setIsValidating] = useState(true)
  
  useEffect(() => {
    if (!loading && organizations.length > 0) {
      setIsValidating(false)
    }
  }, [loading, organizations])
  
  // Show loading while validating
  if (isValidating || loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-pulse">Loading organization...</div>
      </div>
    )
  }
  
  // Check if the org slug is valid
  const validOrg = organizations.find(org => org.slug === orgSlug && org.accepted)
  
  if (!validOrg) {
    // Try to get the last valid organization
    const lastOrg = localStorage.getItem('activeOrganization')
    const lastOrgValid = lastOrg && organizations.find(org => org.slug === lastOrg && org.accepted)
    
    if (lastOrgValid) {
      // Redirect to the last valid organization
      return <Navigate to={`/${lastOrg}/edge`} replace />
    }
    
    // No valid last org, redirect to organizations page
    return <Navigate to="/organizations" replace />
  }
  
  // Valid org slug, render children
  return <>{children}</>
}